import { css, keyframes } from "styled-components";

export const slideIn = (
  from = "10px",
  direction = "vertical",
  duration = "0.5s",
  fillMode = "none"
) => {
  const transform = direction === "horizontal" ? "translateX" : "translateY";

  const slideInAnimation = keyframes`
          from {
            opacity: 0;
            transform: ${transform}(${from});
          }
          to {
            opacity: 1;
            transform: ${transform}(0px);
          }
        `;

  return css`
    animation: ${slideInAnimation} ${duration} ${fillMode};
  `;
};
